import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { toast } from "react-toastify";

const ReactQuery = ({ children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        retry: 0,
        onError: (err) => {
          toast.error(
            err?.response?.data?.message || err?.response?.data?.error
          );
        },
      },
      queries: {
        refetchOnMount: false,
        staleTime: 5 * 1000 * 60,
        cacheTime: 10 * 1000 * 60,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        retry: 0,
        onError: (err) => {
          toast.error(
            err?.response?.data?.message || err?.response?.data?.error
          );
        },
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};

export default ReactQuery;
